import { kebabCase } from 'change-case';

/**
 * Create a kebab-case slug for an integration from an integrationName (e.g., "Snap Ads") or from a camelCaseSlug (e.g., "snapAds").
 * @returns a kebab-cased slug for the integration.
 */
export function slugifyIntegration({
  integrationName,
  camelCaseIntegrationSlug,
}:
  | { integrationName: string; camelCaseIntegrationSlug?: undefined }
  | { integrationName?: undefined; camelCaseIntegrationSlug: string }): string {
  const stringToSlugify = (integrationName ||
    camelCaseIntegrationSlug) as string;

  // TODO: fine-tune case conversion to handle punctuation and other edge cases like (8x8 => 8-x8)
  return kebabCase(stringToSlugify.trim());
}
